var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQTicket = function SvgQTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.895 4.632c1.162 0 2.105.942 2.105 2.105v3.157c-1.104 0-2 .943-2 2.106 0 1.09.787 1.987 1.796 2.095l.204.01v3.158a2.106 2.106 0 0 1-2.105 2.106H4.105A2.106 2.106 0 0 1 2 17.263v-3.158c1.105 0 2-.943 2-2.105 0-1.09-.787-1.986-1.795-2.094L2 9.894V6.737c0-1.163.943-2.105 2.105-2.105z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.105,
    height: 2.105,
    x: 14.842,
    y: 6,
    fill: "#fff",
    rx: 0.164
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.105,
    height: 2.105,
    x: 14.842,
    y: 9.158,
    fill: "#fff",
    rx: 0.164
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.105,
    height: 2.105,
    x: 14.842,
    y: 12.316,
    fill: "#fff",
    rx: 0.164
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.105,
    height: 2.105,
    x: 14.842,
    y: 15.474,
    fill: "#fff",
    rx: 0.164
  })));
};
export { SvgQTicket as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5Ljg5NDUgNC42MzE1OUMyMS4wNTcyIDQuNjMxNTkgMjIgNS41NzQzNiAyMiA2LjczNzA2VjkuODk0MjlDMjAuODk1NiA5Ljg5NDQxIDIwLjAwMDEgMTAuODM3MiAyMCAxMS45OTk4QzIwIDEzLjA4OTkgMjAuNzg3MyAxMy45ODY4IDIxLjc5NTkgMTQuMDk0NUwyMiAxNC4xMDUyVjE3LjI2MzRDMjEuOTk5OSAxOC40MjYgMjEuMDU3MSAxOS4zNjg5IDE5Ljg5NDUgMTkuMzY4OUg0LjEwNTQ3QzIuOTQyODUgMTkuMzY4OSAyLjAwMDE0IDE4LjQyNiAyIDE3LjI2MzRWMTQuMTA1MkMzLjEwNDU3IDE0LjEwNTIgNCAxMy4xNjI1IDQgMTEuOTk5OEMzLjk5OTkgMTAuOTEgMy4yMTMzMyAxMC4wMTQgMi4yMDUwOCA5LjkwNjAxTDIgOS44OTQyOVY2LjczNzA2QzIgNS41NzQzNiAyLjk0Mjc2IDQuNjMxNTkgNC4xMDU0NyA0LjYzMTU5SDE5Ljg5NDVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeD0iMTQuODQxOCIgeT0iNiIgd2lkdGg9IjIuMTA1MjYiIGhlaWdodD0iMi4xMDUyNiIgcng9IjAuMTY0NDc0IiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSIxNC44NDE4IiB5PSI5LjE1Nzk2IiB3aWR0aD0iMi4xMDUyNiIgaGVpZ2h0PSIyLjEwNTI2IiByeD0iMC4xNjQ0NzQiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjE0Ljg0MTgiIHk9IjEyLjMxNTgiIHdpZHRoPSIyLjEwNTI2IiBoZWlnaHQ9IjIuMTA1MjYiIHJ4PSIwLjE2NDQ3NCIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMTQuODQxOCIgeT0iMTUuNDczOCIgd2lkdGg9IjIuMTA1MjYiIGhlaWdodD0iMi4xMDUyNiIgcng9IjAuMTY0NDc0IiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";